import React from 'react';
import PropTypes from 'prop-types';

// Components
import Tooltip from 'components/widgets/overlays/tooltip';


export default function Truncate({ textContent, elementType = 'div', children, tooltip }) {
  const text = textContent || children;
  const title = tooltip || textContent || children;

  return (
    <Tooltip className="truncate-with-ellipses" title={title} elementType={elementType} data-truncate-content={text}>
      <span>{children}</span>
    </Tooltip>
  );
}

Truncate.propTypes = {
  textContent: PropTypes.string,
  tooltip: PropTypes.any,
  elementType: PropTypes.string,
  children: PropTypes.node
};



// WEBPACK FOOTER //
// ./app/components/widgets/text/truncate.js